/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Socialnetworks_Link_Placeholder1Inputs */

const en_company_profile_socialnetworks_link_placeholder1 = /** @type {(inputs: Company_Profile_Socialnetworks_Link_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. https://linkedin.com/...`)
};

const de_company_profile_socialnetworks_link_placeholder1 = /** @type {(inputs: Company_Profile_Socialnetworks_Link_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. https://linkedin.com/...`)
};

/**
* | output |
* | --- |
* | "e.g. https://linkedin.com/..." |
*
* @param {Company_Profile_Socialnetworks_Link_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_profile_socialnetworks_link_placeholder1 = /** @type {((inputs?: Company_Profile_Socialnetworks_Link_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Socialnetworks_Link_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_socialnetworks_link_placeholder1(inputs)
	return en_company_profile_socialnetworks_link_placeholder1(inputs)
});
export { company_profile_socialnetworks_link_placeholder1 as "company_profile_socialNetworks_link_placeholder" }